import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e79bf62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content w-[85%] self-center" }
const _hoisted_2 = { class: "text-v_dark_blue" }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-3",
  style: {"border-top-width":"3px"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "period-notice",
  role: "note"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Informativo:"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" A nota fiscal deve ser emitida dentro do mesmo mês de criação do Pedido de Compra. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "Não serão aceitas"),
    /*#__PURE__*/_createTextVNode(" notas fiscais emitidas em mês diferente do mês de criação do Pedido de Compra. ")
  ])
], -1))
const _hoisted_6 = {
  class: "flex justify-between items-start mt-3",
  style: {"align-items":"start"}
}
const _hoisted_7 = { style: {"width":"45%"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning-subtext" }, "(Campo obrigatório para emissão de Nota Fiscal)", -1))
const _hoisted_10 = {
  class: "total",
  style: {"width":"100%","background-color":"#e0e0e0"}
}
const _hoisted_11 = { style: {"color":"#18b95f"} }
const _hoisted_12 = {
  class: "total",
  style: {"width":"100%","background-color":"#e0e0e0"}
}
const _hoisted_13 = { style: {"color":"#18b95f"} }
const _hoisted_14 = {
  class: "total",
  style: {"width":"100%","background-color":"#e0e0e0"}
}
const _hoisted_15 = { style: {"color":"#18b95f"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-5",
  style: {"border-top-width":"3px"}
}, null, -1))
const _hoisted_17 = { class: "flex justify-between items-center" }
const _hoisted_18 = { style: {"width":"50%"} }
const _hoisted_19 = {
  class: "text-v_dark_gray mt-4",
  style: {"width":"45%"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-5",
  style: {"border-top-width":"3px"}
}, null, -1))
const _hoisted_21 = { class: "mt-5 flex justify-center items-center space-x-6" }

import {
	ref,
	onMounted,
	watchEffect,
	withDefaults,
} from "vue"
import Dropzone from "./Dropzone.vue"
import {
	ModalContainer,
	H1,
	H2,
	Input,
	ModalButton,
	ModalContentContainer,
} from "../atoms"
import { updatePdf } from "@/repositories/sendNFS4"
import { IPendingAttachment } from "@/utils/interfaces"
import { ICompanyInfo } from "../../utils/interfaces"
import { getCodRev, revokeCompanySendingPermission } from "@/utils/permissions"
import { companies } from "@/utils/companies"

interface Props {
	fromHome?: boolean
	pendingAttachment?: IPendingAttachment
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AttachmentSendingModal',
  props: {
    fromHome: { type: Boolean },
    pendingAttachment: null
  },
  emits: [
	"enableLoading",
	"closeNoteSendingModal",
	"emitError",
	"successSendingNote",
	"showModal",
],
  setup(__props: any, { emit }) {

const props = __props as { fromHome?: boolean, pendingAttachment?: IPendingAttachment };

let totalComissions = ref("")
let docNum = ref("")
let docFile = ref<File[]>([])
let showButton = ref(false)
let codRev = ref("")
let base = ref("")
const onRequest = ref(false)





const getFile = (file: File[]) => {
	docFile.value = file

	if (file.length == 0) showButton.value = false
	else if (file.length > 0 && docNum.value != "") showButton.value = true
}

const checkFile = () => {
	docNum.value = docNum.value.replace(/\D/g, "")

	if (docFile.value.length > 0 && docNum.value != "") showButton.value = true
	else showButton.value = false
}

const SendNote = async () => {
	showButton.value = false
	emit("enableLoading", true)

	if (!onRequest.value) {
		onRequest.value = true

		const res: any = await updatePdf(
			docNum.value, // InvoiceNumber
			props.pendingAttachment?.pendingAttach?.purchase_order_number, // PurchaseOrder
			codRev.value, // Resaller Code
			base.value, // Base
			docFile.value // File
		)

		if (res?.status == 201) {
			emit("successSendingNote")
			// revokeCompanySendingPermission(base.value)
		} else if (res?.status == 415) {
			emit(
				"emitError",
				"Formato de arquivo inválido. Apenas arquivos PDF são aceitos."
			)
		} else {
			emit("emitError", "Erro ao enviar a nota, entre em contato com o administrador.")
		}

		emit("enableLoading", false)
		onRequest.value = false
	}
}

const companyInfo = ref<ICompanyInfo | null>(null)
const selectedEmpresa = ref("Prime Interway MG")

const updateEmpresaInfo = () => {
	if (selectedEmpresa.value) {
		companyInfo.value = {
			company: selectedEmpresa.value,
			informations: companies[selectedEmpresa.value],
		}
	} else {
		companyInfo.value = null
	}
}

watchEffect(() => {
	updateEmpresaInfo()
})

const baseForNFInfo = (base: string) => {
	const bases: any = {
		"INTERWAY MG": "Prime Interway MG",
		"INTERWAY PR": "Prime Interway PR",
		"INTERWAY SC": "Prime Interway SC",
		"PRIME01 RJ": "RB Code Matriz",
		"PRIME01 SP": "RB Code Filial",
	}
	return bases[base]
}

onMounted(() => {
	codRev.value = getCodRev()
	totalComissions.value = (
		Number(props.pendingAttachment?.pendingAttach?.total_amount) || 0
	).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })

	selectedEmpresa.value = baseForNFInfo(props.pendingAttachment?.pendingAttach?.company || '') || ''
	base.value = (props.pendingAttachment?.pendingAttach?.company || '').replace('01', '').replace(/\s/, '').replace('MG', '')
})

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        width: 15,
        h: "min(50rem, calc(100vh - 2rem))"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(H1), null, {
                default: _withCtx(() => [
                  _createTextVNode("Envio de Nota Fiscal")
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(H2), { class: "text-black opacity-[50%] text-left" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Utilize as seguintes informações para emitir sua Nota Fiscal e faça o upload: ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Informações da empresa:")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, { style: {"padding":"30px","background-color":"rgb(224, 224, 224)","box-shadow":"rgba(0, 0, 0, 0.5) 0px 5px 12px 0px","border":"1px solid #a9adcd"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyInfo.value!.informations, (info) => {
                        return (_openBlock(), _createElementBlock("li", { key: info }, _toDisplayString(info), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Pedido de Compra: "),
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(props.pendingAttachment?.pendingAttach?.purchase_order_number), 1)
                ]),
                _createVNode(_unref(H2), { class: "text-left font-[700] mt-3" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Código de Serviço:")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(props.pendingAttachment?.pendingAttach?.tax_service_code), 1)
                ]),
                _createVNode(_unref(H2), { class: "text-left font-[700] mt-3" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Valor de Comissão:")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(totalComissions)), 1)
                ])
              ])
            ]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(Dropzone, {
                  onGetFile: getFile,
                  total: '0',
                  width: 24
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Número da nota:")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: _unref(docNum),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(docNum) ? (docNum).value = $event : docNum = $event)),
                  onKeyup: checkFile,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_unref(ModalButton), {
                disabled: !_unref(showButton),
                class: "active:scale-90",
                enableButton: _unref(showButton),
                onClick: SendNote
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Enviar ")
                ]),
                _: 1
              }, 8, ["disabled", "enableButton"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})